<template>
  <div class="container">
    <div class="reset-password">
      <div class="mt-4 text-center">
        <img class="panelvue-logo" src="/logo.png" />
      </div>
      <h2 class="page-name text-center">Reset Password</h2>
      <v-layout v-show="errorShow">
        <div style="color:red; text-align:center;">{{message}}</div>
      </v-layout>
      <v-layout v-show="successShow">
        <div style="color:green; text-align:center;">{{message}}</div>
        <br />
      </v-layout>
      <vue-form :state="formstate" @submit.prevent="onSubmit" v-show="!successShow">
        <input type="hidden" id="token" v-model="model.token" required />
        <div class="user-message">Your password is case sensitive and must be at least 6 characters.</div>
        <div class="form-group">
          <validate tag="div">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i class="fa fa-key" aria-hidden="true"></i>
                </div>
              </div>
              <input
                v-model="model.password"
                name="password"
                type="password"
                required
                placeholder="Password"
                class="form-control"
                minlength="6"
              />
            </div>

            <field-messages name="password" show="$invalid && $submitted" class="text-danger">
              <div slot="required">The Password field is required.</div>
              <div slot="minlength">Password must be atleast 6 characters long.</div>
            </field-messages>
          </validate>
        </div>
        <div class="form-group">
          <validate tag="div">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i class="fa fa-key" aria-hidden="true"></i>
                </div>
              </div>
              <input
                v-model="model.password_confirmation"
                name="repeatpassword"
                type="password"
                required
                placeholder="Confirm Password"
                class="form-control"
                :sameas="model.password"
              />
            </div>

            <field-messages name="repeatpassword" show="$invalid && $submitted" class="text-danger">
              <div slot="required">The Confirm Password field is required.</div>
              <div slot="sameas">The Password and Confirm Password fields must match.</div>
            </field-messages>
          </validate>
        </div>
        <div class="form-group text-center">
          <button type="submit" class="btn btn-primary btn-block">Reset Password</button>
        </div>
      </vue-form>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import options from "@/validations/validations.js";
import ApiService from "@/common/api.service";
Vue.use(VueForm, options);
export default {
  name: "resetpassword",
  data() {
    return {
      errorShow: false,
      successShow: false,
      formstate: {},
      message: "",
      model: {
        password: "",
        password_confirmation: "",
        token: ""
      }
    };
  },
  methods: {
    onSubmit: function() {
      if (this.formstate.$invalid) {
        // TODO
      } else {
        let component = this;
        component.message = "";
        this.$web.resetPassword("/auth/password_save", this.model).then(response => {
          if (response.data.success) {
            component.model = {};
            component.message = "Your password has been updated!";
            component.errorShow = false;
            component.successShow = true;
            component.showLoginPage = true;
          } else {
            // component.model.password = '';
            // component.model.password_confirmation = '';
            component.message =
              "An error occurred, unable to update password at this time.";
            component.errorShow = true;
            component.successShow = false;
            component.showLoginPage = false;
          }
        });
      }
    }
  },
  beforeMount() {
    this.model.token = this.$route.params.token;
  },
  mounted: function() {},
  destroyed: function() {}
};
</script>
<style lang="scss">
@import "../../sass/custom.scss";
body {
  background-color: #313d55;
  transition: background-color 0s;
  height: 100vh;
}
.container {
  display: flex;
  justify-content: center;
  flex-direction: row;
}
.page-name {
  margin: 0;
}
.panelvue-logo {
  max-width: 150px;
}
.reset-password {
  max-width: 768px;
  max-height: 500px;
  margin: 20px;
  padding: 20px;
  border: 1px solid black;
  border-radius: 1rem;
  background-color: white;
}
.login-content {
  margin-top: 7%;
  margin-bottom: 7%;
  padding-bottom: 20px;
  box-shadow: 0 0 30px #ccc;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: #ffffff;
}

.img_backgrond {
  background-size: cover;
  height: 100vh;
  width: 100%;
}

label {
  font-size: 14px !important;
}

::-webkit-input-placeholder {
  font-size: 14px;
}

.form-group {
  padding-top: 10px;
}

.user-message {
  padding: 15px 0;
  font-size: 14px;
  color: #777;
}
.img_backgrond .input-group-text {
  background-color: white;
}
.fa {
  color: #ced4da;
}
</style>
